import React from 'react';
import { Toolbar, Box } from '@mui/material';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import SignIn from './pages/auth/SignIn';
import SignUp from './pages/auth/SignUp';
import VerifyEmail from './pages/auth/VerifyEmail';
import {LanguageProvider } from "./contexts/LanguageContext";
import ChangePassword from './pages/auth/ChangePassword';
import ValidateEmail from './pages/auth/ValidateEmail';
import LoadingOverlay from './components/LoadingOverlay';
import AppSnackbar from './components/ErrorSnackbar';
import MarketingPage from './pages/home/MarketingPage';
import StoreCreation from './pages/store-creation/StoreCreation';
import AppAppBar from './components/AppAppBar';
import AppTheme from './theme/AppTheme';
import CssBaseline from '@mui/material/CssBaseline';
import Dashboard from './pages/home/Dashboard';
import TermsAndConditions from './components/TermsAndConditions';
import PrivacyPolicy from './components/PrivacyPolicy';
import StoreEdit from './pages/store-edit/StoreEdit';
import CreateAnnouncement from './pages/announcement/CreateAnnouncement';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import ProtectedRoute from './routes/ProtectedRoute';
import AuthenticatedLayout from './layouts/AuthenticatedLayout';

function RouteShell({
  children,
  appBarProps = {},
  mainSx = { flexGrow: 1, p: 3 },
  includeToolbarSpacer = true,
}) {
  return (
    <Box>
      <AppAppBar {...appBarProps} />
      <Box component="main" sx={mainSx}>
        {includeToolbarSpacer ? <Toolbar /> : null}
        {children}
      </Box>
    </Box>
  );
}

function App() {
  return (
    <LanguageProvider>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Router>
        <LoadingOverlay />
        <AppSnackbar />
        <AppTheme>
          <CssBaseline enableColorScheme />
          <Routes>
            <Route
              path="/"
              element={
                <RouteShell
                  appBarProps={{ hideAuthButtons: true, marketingMode: true }}
                  mainSx={{ flexGrow: 1, p: 0 }}
                  includeToolbarSpacer={false}
                >
                  <MarketingPage />
                </RouteShell>
              }
            />
            <Route
              path="/terms-and-conditions"
              element={
                <RouteShell appBarProps={{ hideNavigation: true, hideAuthButtons: true }} mainSx={{ flexGrow: 1, p: 3 }}>
                  <TermsAndConditions />
                </RouteShell>
              }
            />
            <Route
              path="/privacy-policy"
              element={
                <RouteShell appBarProps={{ hideNavigation: true, hideAuthButtons: true }} mainSx={{ flexGrow: 1, p: 3 }}>
                  <PrivacyPolicy />
                </RouteShell>
              }
            />
            <Route
              path="/signin"
              element={
                <RouteShell appBarProps={{ hideNavigationOnly: true }} mainSx={{ flexGrow: 1 }}>
                  <SignIn />
                </RouteShell>
              }
            />
            <Route
              path="/signup"
              element={
                <RouteShell appBarProps={{ hideNavigationOnly: true }} mainSx={{ flexGrow: 1 }}>
                  <SignUp />
                </RouteShell>
              }
            />
            <Route
              path="/verify-email"
              element={
                <RouteShell appBarProps={{ hideNavigationOnly: true }}>
                  <VerifyEmail />
                </RouteShell>
              }
            />
            <Route
              path="/change-password"
              element={
                <RouteShell appBarProps={{ hideNavigationOnly: true }}>
                  <ChangePassword />
                </RouteShell>
              }
            />
            <Route
              path="/validate-email"
              element={
                <RouteShell appBarProps={{ hideNavigationOnly: true }}>
                  <ValidateEmail />
                </RouteShell>
              }
            />

            <Route element={<ProtectedRoute />}>
              <Route element={<AuthenticatedLayout />}>
                <Route path="/home" element={<Dashboard />} />
                <Route path="/store-creation" element={<StoreCreation />} />
                <Route path="/store-edit/:storeId" element={<StoreEdit />} />
                <Route path="/announcement-creation" element={<CreateAnnouncement />} />
              </Route>
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AppTheme>
      </Router>
      </LocalizationProvider>
    </LanguageProvider>
  );
}

export default App;
